module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/review_stars_4689d8538751929b15152a12821f0610.png";